import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store/store';

const selectPoi = (state: AppState) => state.poi;

export const selectIds = createSelector(selectPoi, (poi) => poi?.ids);
